<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
        <Table :fields="fields" :items="list" :filtered="filtered" type="List" :loading="loading" 
        :actions="actions" :actionEvent="actionEvent" addUrl="User/LDAP/Filters/Add" :goDetail="goDetail"/>

        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" :onComplete="complete" />
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import Table from "@/components/Table"
    import i18n from '@/plugins/i18n';
    import Modals from "./modals/";

    let breadCrumb = [
        { label: 'AD / LDAP', url: "" },
        { label: 'LDAP Filtreleri', url: "/User/LDAP/Filters" },
    ]
     let fields = [ 
         { key: 'description', label: 'Filtre Açıklaması', keys:['description'] },
         { key: 'actions', label: i18n.t('user.list.actions') }        
    ]; 

    let actions = [
        {key: 'run', text: 'Filtreyi Çalıştır'},
        {key: 'delete', text: 'Filtreyi Sil'}
    ]

    let filtered = ['description', 'actions']; 

    export default {
        name: 'FilterList',
         created: async function(){
            await this.$store.dispatch('adfilter_list')
        },
        computed:{
            fetchData(){
                this.$store.dispatch('adfilter_list')
            },
            loading(){
                return this.$store.getters.getLDAPLoading
            },
            list(){
                return this.$store.getters.getADFilters

            },
        },
        data: function(){
            return{
                breadCrumb, fields, filtered, actions, modalOpen: false,
                modalProps: {}, currentForm:"ADFilter", modalName: ""
            }
        },
        components:{
            BreadCrumb, Table, Modals
        },
        methods:{
            goDetail(item){
                this.$router.push( { path: '/User/LDAP/Filter/'+item.id+'/edit' })
            },
            actionEvent: async function(key, data){
                switch(key){
                    case 'run': 
                        this.currentForm = 'LDAPData'
                        await this.$store.dispatch('adfilter_run', {id: data.id})
                        this.openModal(true, 'LDAPData', data)
                        break;
                    case 'delete':
                        this.currentForm = 'ADFilter'

                        this.openModal(true, 'delete', data)
                        break;
                }
            },
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Users/LDAPFilters.vue